import { useState } from 'react';
import { AdviseSupplierContract } from '../../../../types/advise';
import { TextSpan } from '../../../Atoms/Text';
import { TextButton } from '../../../Atoms/TextButton';
import { ContractFields, ContractFieldsProps } from './ContractFields';

const hasDetails = (contract: AdviseSupplierContract) => Object.values(contract).some((value) => value != null);

/** The supplier's optional contract details, collapsed behind "+ Add contract details" until there are some. */
export const ContractDetails = (props: ContractFieldsProps) => {
  const [expanded, setExpanded] = useState(() => hasDetails(props.contract));

  if (expanded || hasDetails(props.contract)) return <ContractFields {...props} />;
  if (!props.canEdit)
    return (
      <TextSpan
        size="xs"
        color="grey6">
        No contract details
      </TextSpan>
    );
  return (
    <div className="flex items-center gap-2">
      <TextButton onClick={() => setExpanded(true)}>+ Add contract details</TextButton>
      <TextSpan
        size="xs"
        color="grey6">
        Optional — end date, term, termination fee
      </TextSpan>
    </div>
  );
};
